import { reactive } from 'vue';

export const store = reactive({
  formGerais: {},
  formObjeto: {},
  formProblema: {},
  formProduto: {},
  formServicos: {},
  formPagamentos: {},
  formObservacoes: {},
  formAnexos: {},
  orcamentos: [],
  isUpdate: false,
  currentTab: 0,
  dataFetching: {
    produtos: true,
    servicos: true,
  },
  pafNFCe: false,
  trabalharHorasOs: false,
  trabalharNumeroInternoOs: false,
});
